import { Component } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import {TokenStorage} from '../../core/token.storage';
 
// const URL = '/api/';
//const URL = 'https://evening-anchorage-3159.herokuapp.com/api/';
//const URL = '/sonavie/uploadFile';
const URL = 'http://192.168.1.229:8000/sonavie/uploadFile';
 


@Component({
  selector: 'ngfile',
  templateUrl: './ngfile.component.html',
  styleUrls: ['./ngfile.component.css']
})
export class NgFileComponent {
  constructor(private token: TokenStorage) { }
  public uploader:FileUploader = new FileUploader({url: URL, authToken: this.token.getToken()});
  public hasBaseDropZoneOver:boolean = false;
  public hasAnotherDropZoneOver:boolean = false;
 
  public fileOverBase(e:any):void {
    this.hasBaseDropZoneOver = e;
  }
 
  public fileOverAnother(e:any):void {
    this.hasAnotherDropZoneOver = e;
  }
}


// WEBPACK FOOTER //
// ./src/app/admin-app/ngfile/ngfile.component.ts